import styled, { keyframes } from "styled-components";

const expandAnimation = keyframes`
    from {
        max-height: 0;
        opacity: 0;
    }
    to {
        max-height: 800px;
        opacity: 1;
    }
`;

export const AnimatedWrapper = styled.div`
    animation: ${expandAnimation} 0.3s ease-in-out forwards;
`;
